import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'chp-delivery-and-sales-order-numbers',
  templateUrl: './delivery-and-sales-order-numbers.component.html',
  styleUrls: ['./delivery-and-sales-order-numbers.component.scss']
})
export class DeliveryAndSalesOrderNumbersComponent implements OnInit {

  @Input()
  public stringDeliveryNumbers = '';

  @Input()
  public deliveryNumbers: string[] = [];

  @Input()
  public stringSalesOrderNumbers = '';

  @Input()
  public salesOrderNumbers: string[] = [];

  constructor() { }

  ngOnInit(): void {
    if (this.stringDeliveryNumbers == null || this.stringDeliveryNumbers === '') {
      this.stringDeliveryNumbers = this.convertToDisplayableString(this.deliveryNumbers);
    }
    if (!this.stringSalesOrderNumbers == null || this.stringSalesOrderNumbers === '') {
      this.stringSalesOrderNumbers = this.convertToDisplayableString(this.salesOrderNumbers);
    }
  }

  private convertToDisplayableString(list: string[]): string {
    return list
      .filter(s => s !== null)
      .map(number => `#${number}`)
      .filter((s, index, self) => self.indexOf(s) === index)
      .join(', ');
  }

}
